/* eslint-disable */
export function exportExcel (fileName, res) {
  let blob = new Blob([res], { type: 'application/vnd.ms-excel' });
  if (window.navigator.msSaveOrOpenBlob) {
    //兼容 IE & EDGE
    window.navigator.msSaveBlob(blob, fileName);
  } else if (typeof window.chrome !== 'undefined') {
    const a = document.createElement('a');
    a.addEventListener('click', function () {
      a.download = fileName
      a.href = URL.createObjectURL(blob)
    })
    var e = document.createEvent('MouseEvents')
    e.initEvent('click', false, false)
    a.dispatchEvent(e)
  } else {
    var file = new File([res], fileName, { type: 'application/force-download' });
    // window.open(URL.createObjectURL(file));
    let downloadElement = document.createElement('a');
    let href = window.URL.createObjectURL(blob); //创建下载的链接
    downloadElement.href = href;
    downloadElement.download = fileName;//下载后文件名
    document.body.appendChild(downloadElement);
    //此写法兼容火狐
    let evt = document.createEvent("MouseEvents");
    evt.initEvent("click", false, false);
    downloadElement.dispatchEvent(evt);
    document.body.removeChild(downloadElement);
  }
}
export function excel (fileName, res) {
  console.log(res, 5)
  let blob = new Blob([res])
  let linkNode = document.createElement('a')
  linkNode.download = fileName //a标签的download属性规定下载文件的名称
  linkNode.style.display = 'none'
  linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
  document.body.appendChild(linkNode)
  linkNode.click() //模拟在按钮上的一次鼠标单击
  URL.revokeObjectURL(linkNode.href) // 释放URL 对象
  document.body.removeChild(linkNode)
}
export function exportPdf2 (fileName, res) {
  console.log(res)
  let blob = new Blob([res])
  let linkNode = document.createElement('a')
  linkNode.download = fileName //a标签的download属性规定下载文件的名称
  linkNode.style.display = 'none'
  linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
  document.body.appendChild(linkNode)
  linkNode.click() //模拟在按钮上的一次鼠标单击
  URL.revokeObjectURL(linkNode.href) // 释放URL 对象
  document.body.removeChild(linkNode)
}
export function exportPdf (fileName, res) {
  let blob = new Blob([res], { type: 'application/pdf' });
  console.log(blob);

  if (window.navigator.msSaveOrOpenBlob) {
    //兼容 IE & EDGE
    window.navigator.msSaveBlob(blob, fileName);
  } else if (typeof window.chrome !== 'undefined') {
    const a = document.createElement('a');
    a.addEventListener('click', function () {
      a.download = fileName
      a.href = URL.createObjectURL(blob)
    })
    var e = document.createEvent('MouseEvents')
    e.initEvent('click', false, false)
    a.dispatchEvent(e)
  } else {
    var file = new File([res], fileName, { type: 'application/force-download' });
    // window.open(URL.createObjectURL(file));
    let downloadElement = document.createElement('a');
    let href = window.URL.createObjectURL(blob); //创建下载的链接
    downloadElement.href = href;
    downloadElement.download = fileName;//下载后文件名
    document.body.appendChild(downloadElement);
    //此写法兼容火狐
    let evt = document.createEvent("MouseEvents");
    evt.initEvent("click", false, false);
    downloadElement.dispatchEvent(evt);
    document.body.removeChild(downloadElement);
  }
}


// WEBPACK FOOTER //
// ./src/utils/excel.js